import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

class VerbCheckboxInput extends Component {
    static propTypes = {
        label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        value: PropTypes.any,
        onChange: PropTypes.func,
        className: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = { isSelected: props.value };
    }

    _handleOptionSelect = () => {
        this.setState({ isSelected: !this.state.isSelected });
        if (this.props.onChange) {
            this.props.onChange(!this.state.isSelected);
        }
    };

    render() {
        const { value, label, className } = this.props;
        const { isSelected } = this.state;

        const onClick = () => this._handleOptionSelect(value);

        return (
            <div className={cns('verbCheckboxWrapper', className)}>
                <div
                    key={value}
                    className={cns('verbCheckboxOption', { 'verbCheckboxOption-selected': isSelected })}
                    onClick={onClick}
                    onKeyPress={onClick}
                >
                    <div className={cns('verbCheckboxOption-item')} tabIndex={'0'} />
                    <div className={'verbCheckboxOption-label'}>{label}</div>
                </div>
            </div>
        );
    }
}

export default VerbCheckboxInput;
